<template>
  <div class="navigation flex-row">
    <div
      class="item flex-column flex-main-axis-center flex-cross-axis-center"
      v-for="(item, index) in items"
      :key="'navbar' + index"
      @click="goPath(index)"
    >
      <img class="image" :src="getIcon(selected, index)" alt="" />
      <div :class="'title ' + (selected === index ? 'title-highlight' : '')">{{ item.title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {
    selected() {
      return this.$store.state.navSelected;
    }
  },
  props: {
    items: {
      type: Array,
      require: true
    }
  },
  created() {
    // this.resetCurrSelected();
  },
  methods: {
    goPath(index) {
      this.replace(this.items[index].url);
    },
    getIcon(selected, index) {
      let item = this.items[index];
      return index !== selected ? item.icon : item.selectedIcon;
    },
  }
};
</script>

<style scoped>
.navigation {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  font-size: 12px;
  height: 52px;
  justify-content: space-around;
  box-shadow: 0 -2px 2px 0 #eee;
}
.item{
  flex: 1 1;
}
.item:active {
  filter: opacity(0.5);
}

.item .image {
  width: 24px;
  height: 24px;
  margin-bottom: 2px;
}

.title{
  font-size: 10px;
  color: black;
}

.title-highlight{
  color: #ED2F2F;
}
</style>